import { useQuery } from "@tanstack/react-query";
import { type NickNameType } from "~/src/models/profile/user-info";
import { type NicknamesResponse } from "~/src/models/secure-chat";
import { useCurrentUserId, useAuthStore } from "~/src/store/use-auth-store";
import { nicknamePageQueryOptions } from "./nickname-page-query";

const selectNicknames = (
  data: NicknamesResponse
): Map<string, NickNameType | null> =>
  new Map(
    data.users.map((user) => [user.nickname?.friend_id ?? "", user.nickname])
  );

export const useGetAllNickNames: any = () => {
  const accountId = useCurrentUserId();
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const { data, isPending, error } = useQuery({
    ...nicknamePageQueryOptions(accountId, 1),
    select: selectNicknames,
    enabled: isLoggedIn && !!accountId,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    retry: false,
  });
  return { data, isPending, error };
};
